export default "__VITE_PUBLIC_ASSET__43df80df__"